<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="main-top-group">
	<!--  	   	 	 -->
	<!-- TOP SECTION -->
	<!-- 			 -->
	<div class="column-group">
		<div class="column1">
			<!-- 	     -->
			<!-- School  -->
			<!-- 	     -->
			<div class="column-item">
				<div>
					<label class="column-item-label">School</label>
				</div>

				<div style="margin-left: 10px">
					<p-radioButton
						name="group1"
						[disabled]="isAdd == false || UserLevelID != 1"
						value="1"
						label="All Schools"
						[(ngModel)]="selectedGroupValue"
					></p-radioButton>
				</div>

				<div style="margin-left: 10px">
					<p-radioButton
						name="group1"
						[disabled]="isAdd == false"
						value="2"
						label="Current School Only"
						[(ngModel)]="selectedGroupValue"
					></p-radioButton>
				</div>
			</div>

			<!-- 	     -->
			<!-- CODE    -->
			<!-- 	     -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Code</label>
				</div>

				<div style="margin-left: 10px">
					<input type="text" pInputText [(ngModel)]="rAlertCD" maxlength="50" style="width: 350px" [disabled]="isViewOnly == true" />
				</div>

				<div>
					<label class="column-item-label">Max 50 characters</label>
				</div>
			</div>
			<!-- 	     	 -->
			<!-- Description -->
			<!-- 	     	 -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Description</label>
				</div>

				<div style="margin-left: 10px">
					<input type="text" pInputText [(ngModel)]="rAlertDesc" maxlength="100" style="width: 350px" [disabled]="isViewOnly == true" />
				</div>

				<div>
					<label class="column-item-label">Max 100 characters</label>
				</div>
			</div>
			<!-- 	     -->
			<!-- Message -->
			<!-- 	     -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Message</label>
				</div>

				<div style="margin-left: 10px">
					<p-colorPicker [(ngModel)]="rMessagecolor" [disabled]="isViewOnly == true"></p-colorPicker>
				</div>

				<div style="margin-left: 2px">
					<input
						type="text"
						pInputText
						[(ngModel)]="rMessage"
						[style.color]="rMessagecolor"
						maxlength="100"
						style="width: 640px"
						[disabled]="isViewOnly == true"
					/>
				</div>

				<div>
					<label class="column-item-label">Max 100 characters</label>
				</div>
			</div>

			<!--  	   	            -->
			<!-- Priority Selector  -->
			<!-- 		            -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Priority</label>
				</div>

				<div style="margin-left: 10px; width: 153px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="SelectedPrioritySelector"
						style="font-size: smaller"
						[disabled]="isViewOnly == true"
						[(ngModel)]="SelectedPriority"
						(ngModelChange)="onPriorityChange($event)"
					>
						<option *ngFor="let r of lstPriorityItems" [ngValue]="r">
							{{ r.PriorityDesc }}
						</option>
					</select>
				</div>
			</div>

			<!--  	   	            -->
			<!-- Frequency Selector  -->
			<!-- 		            -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Frequency</label>
				</div>

				<div style="margin-left: 10px; width: 153px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="SelectedFrequencySelector"
						style="font-size: smaller"
						[disabled]="isViewOnly == true"
						[(ngModel)]="SelectedFrequency"
						(ngModelChange)="onFrequencyChange($event)"
					>
						<option *ngFor="let r of lstFrequencyItems" [ngValue]="r">
							{{ r.AlertFrequencyDesc }}
						</option>
					</select>
				</div>
			</div>

			<!--  	   	         -->
			<!-- Sound Selector  -->
			<!-- 		         -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Sound</label>
				</div>

				<div style="margin-left: 10px; width: 153px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="SelectedSoundSelector"
						style="font-size: smaller"
						[disabled]="isViewOnly == true"
						[(ngModel)]="SelectedSound"
						(ngModelChange)="onSoundChange($event)"
					>
						<option *ngFor="let r of lstSoundItems" [ngValue]="r">
							{{ r.SoundFile }}
						</option>
					</select>
				</div>

				<div style="margin-left: 5px">
					<button class="btn btn-primary btn-sm" style="margin-left: 5px" (click)="onPlay()" [disabled]="isBusy == true">Play</button>
					<button class="btn btn-primary btn-sm" style="margin-left: 5px" (click)="onStop()" [disabled]="isBusy == true">Stop</button>
				</div>

				<!-- 				   -->
				<!-- Display When Busy -->
				<!-- 				   -->
				<div style="margin-left: 15px; width: 20px" [style.display]="isBusy == true ? 'block' : 'none'">
					<img class="busy-img" src="assets/images/loading.gif" />
				</div>
			</div>
		</div>
	</div>
</div>

<!--				-->
<!-- Error Message  -->
<!--				-->
<div class="main-error-group" [style.display]="ErrorMessage.length == 0 ? 'none' : 'block'">
	<div class="error-div">
		<label class="error-message">{{ ErrorMessage }}</label>
	</div>
</div>

<!-- 		 -->
<!-- Buttons -->
<!-- 		 -->
<div style="margin-top: 20px">
	<button class="btn btn-primary" style="margin-left: 0px" (click)="onAddUpdate()" [disabled]="isBusy == true || isViewOnly == true">Save</button>
	<button class="btn btn-primary" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
